export const ACBatteriesNotReportingTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems
                    list</span>, and <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">Devices tab</span>.
            </li>
            <li>
                <span className="font-semibold">Verify</span> no interfering devices are on the same circuit as the
                Gateway.
            </li>
            <li>
                <span className="font-semibold">Remove</span> potential sources of interference, such as CFLs.
            </li>
            <li>
                <span className="font-semibold">Check</span> the AC Battery status on
                the <span className="font-semibold">Devices</span> list if issues persist.
            </li>
            <li>
                <span className="font-semibold">Consult</span> the <span className="font-semibold">Enphase AC
                    Battery Manual</span> or <span className="font-semibold">contact Customer Support</span> if needed.
            </li>
        </ul>
    </div>
